class CeRotator {
	constructor(options) {
		const defaultOptions = {
			container: '.rotator',
			containerWrapper: '.rotator__slider-wrapper',
			rotatorSelector: '.rotator__slider',
			slideSelector: '.rotator__slide',
			controlSelector: '.rotator__controls',
			prevBtnSelector: '.rotator__nav-btn--prev',
			nextBtnSelector: '.rotator__nav-btn--next',
			autoRotate: 'data-auto-rotation',
			intervalTime: 6000,
			isDown: false, // Tracks if user is swiping currently
			swipePointX: 0, // start point x for swiping
			swipePointY: 0, // start point y for swiping
			swipeLeft: 0
		};

		// Merge default options with user-provided options
		this.options = { ...defaultOptions, ...options };

		this.container    = document.querySelector(this.options.container);

		if ( this.container ) {
			this.rotator      = this.container.querySelector(this.options.rotatorSelector);
			this.wrapper      = this.container.querySelector(this.options.containerWrapper);
			this.slides       = this.rotator.querySelectorAll(this.options.slideSelector);
			if (this.options.controlSelector) {
				this.controls = this.container.querySelector(this.options.controlSelector);
			}
			if (this.controls) {
				this.prevBtn = this.controls.querySelector(this.options.prevBtnSelector);
				this.nextBtn = this.controls.querySelector(this.options.nextBtnSelector);
			}
			this.autoRotation = this.rotator.getAttribute(this.options.autoRotate);
			this.intervalTime = this.options.intervalTime;
			this.slideIndex   = 0;
			this.interval     = null;
			this.slideWidth   = this.slides[0].offsetWidth; // width of each slide
		}

		if ( this.rotator && this.slides.length > 1 ) {
			this.init();
		}
	}

	init() {
		this.startAutoRotation();

		this.rotator.addEventListener( 'mouseenter', () => {
			this.stopAutoRotation();
		} );

		this.rotator.addEventListener( 'mouseleave', () => {
			this.startAutoRotation();
		} );

		this.rotator.addEventListener( 'touchstart', (e) => {
			if (this.rotator.children.length <= 1) return;
			this.stopAutoRotation();
			this.isDown = true; // setting swiping state
			this.wrapper.style.scrollBehavior = 'auto'; // disable smooth scrolling during swiping
			this.swipePointX = e.touches[0].pageX - this.rotator.offsetLeft; // track starting x positions
			this.swipePointY = e.touches[0].pageY; // track starting y position
			this.swipeLeft = this.wrapper.scrollLeft; // track starting scroll position

		})

		this.rotator.addEventListener( 'touchmove', (e) => {
			this.stopAutoRotation();

			if (!this.isDown) return; // exit if not swiping

			const xPos = e.touches[0].pageX - this.rotator.offsetLeft; // current x position
			const yPos = e.touches[0].pageY; // current y position

			const distMoved = (xPos - this.swipePointX) * 3; // calculating distance moved

			const diffX = Math.abs(xPos - this.swipePointX);
			const diffY = Math.abs(yPos - this.swipePointY);

			// it the swipe is more vertical stop swiping left or right
			if( diffY > diffX) {
				this.isDown = false
				return;
			}

			e.preventDefault();
			this.wrapper.scrollLeft = this.swipeLeft - distMoved; // update scroll position during swiping
		})

		this.rotator.addEventListener( 'touchend', () => {
			if (this.isDown) {
				this.stopAutoRotation();
				this.isDown = false; // reseting swipe state

				const scrollAmount = this.wrapper.scrollLeft; // getting current scroll position
				let index = Math.round( scrollAmount / this.slideWidth ); // closest slide
				this.slideIndex = index;
				this.wrapper.style.scrollBehavior = 'smooth'; // smooth scrolling enable
				this.updateSlider();
			}
		});

		if ( this.prevBtn ) {
			this.prevBtn.addEventListener( 'click', () => {
				if (this.rotator.children.length <= 1) return;
				// get prev slide
				this.stopAutoRotation();
				this.slideIndex = Math.max(this.slideIndex - 1, 0); // decrease slide index,not under 0
				this.wrapper.style.scrollBehavior = 'smooth';
				this.updateSlider();
			} );
		}

		if ( this.nextBtn ) {
			this.nextBtn.addEventListener( 'click', () => {
				if (this.rotator.children.length <= 1) return;
				// get next slide
				this.stopAutoRotation();
				this.slideIndex = (this.slideIndex + 1 ) % this.rotator.children.length; // increase slide index and loop back to first slide after last
				this.wrapper.style.scrollBehavior = 'smooth';
				this.updateSlider();
			} );
		}

		// resizing on shrinking or growing window
		window.addEventListener( 'resize', () => {
			this.slideWidth = this.rotator.clientWidth;
			this.updateSlider();
			this.debouncedResizeHandler;
		});

	}

	/**
	 * Debounce function to optimize the CPU performance
	 * @param {function} func function to debounce
	 * @param {int} wait wating time to debounce
	 * @returns function
	 */
	debounce = (func, wait) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				func.apply(this, args);
			}, wait);
		};
	}

	debouncedResizeHandler = this.debounce(() => {
		this.updateSlider();
		this.resizeSlider();
	}, 200);


	updateSlider() {
		if( this.rotator ) {
			const slideWidth = this.rotator.clientWidth; // calculate scroll position
			this.wrapper.scrollLeft = slideWidth * this.slideIndex; // set scroll position
		}
	}

	nextAutoSlide = () => {
		if (this.rotator.children.length <= 1) return;
		this.slideIndex = ( this.slideIndex + 1 ) % this.rotator.children.length;
		this.wrapper.style.scrollBehavior = 'smooth';
		this.updateSlider();
	}

	startAutoRotation() {
		if ( this.autoRotation === '1' && this.rotator.children.length > 1) {
			this.interval = setInterval(this.nextAutoSlide, this.intervalTime);
		}
	}

	stopAutoRotation() {
		clearInterval(this.interval);
	}

	resizeSlider() {
		this.updateSlider();
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const ceRotator = new CeRotator();
} );
